import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <img 
            src="/images/yhgs-logo.png" 
            alt="养花怪兽阅读馆"
            width="64"
            height="64"
            loading="lazy"
          />
          <h1 className="logo-title">养花怪兽阅读馆</h1>
        </div>

        <div className="nav-wrapper">
          <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
            <ul>
              <li><a href="/" className="nav-link">首页</a></li>
              <li><a href="/books" className="nav-link">绘本推荐</a></li>
              <li><a href="/events" className="nav-link">热门活动</a></li>
              <li><a href="/membership" className="nav-link">会员服务</a></li>
            </ul>
          </nav>
          <button 
            className={`menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle navigation"
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
